module.exports = __webpack_public_path__ + "static/size_icon-f709b0efb7f33efc9ffc24f32080369a.svg";